import React from 'react';
import { setCurrentView } from 'core/utils';
import { ShipmentCostChargeListTemplate } from 'themes/modules/shipment-cost/pages';
import { ShipmentCostChargeListViewStore } from 'modules/shipment-cost/stores';

@setCurrentView(rootStore => new ShipmentCostChargeListViewStore(rootStore), 'shipmentCostChargeListViewStore')
class ShipmentCostChargeList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ShipmentCostChargeListTemplate {...this.props} viewStore={this.props.shipmentCostChargeListViewStore} />;
	}
}

export default ShipmentCostChargeList;



// WEBPACK FOOTER //
// ./src/modules/shipment-cost/pages/ShipmentCostChargeList.jsx